import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { value: "" }
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 0,
  class: "panel"
}
const _hoisted_5 = { value: "" }
const _hoisted_6 = ["value"]

import { computed, onMounted, ref, watch } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Partner, usePartner, invoiceTargetNames } from '../Partner';
import { ErrorBag, handleFormError } from '@/core/common';
import { getAllMarkets, Market } from '@/modules/parameters/Market';
import { CompanyRecord } from '@/modules/company_record/CompanyRecord';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppButton from '@/core/components/form/AppButton.vue';
import PageLayout from '@/core/components/PageLayout.vue';
import AppInput from '@/core/components/form/AppInput.vue';
import AppCompanyRecordInput from '@/modules/company_record/components/AppCompanyRecordInput.vue';
import AppSelect from '@/core/components/form/AppSelect.vue';
import AppCheck from '@/core/components/form/AppCheck.vue';

interface PartnerFormProps {
	pageTitle: string;
	partner: Partner;
	forCreate: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PartnerForm',
  props: {
    pageTitle: {},
    partner: {},
    forCreate: { type: Boolean }
  },
  emits: [
	'cancel',
	'saved',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { $gettext } = useGettext();
const resource = usePartner();
const markets = ref<Market[]>([]);
const errors = ref<ErrorBag>({});
const data = ref<Partial<Partner>>({});
const market = computed({
	get() {
		return data.value.market?.id;
	},
	set(value: number) {
		data.value.market = {
			id: value,
		};
	},
});

// Set data to form on mount and when the prop value changes.
const setData = () => data.value = Object.assign({}, props.partner);
onMounted(async () => {
	markets.value = await getAllMarkets();
	setData();
});
watch(() => props.partner, setData);

const handleCompanyRecordResult = (record: CompanyRecord) => {
	data.value.name = record.name;
	data.value.phone = record.phone;
	data.value.invoice.address = record.address;
	data.value.invoice.city = record.city;
	data.value.invoice.zipcode = record.zip;
};

const save = async () => {
	errors.value = {};

	const postBody: Partner = Object.assign({}, data.value) as Partner;
	postBody.market = market.value;

	let promise: Promise<Partner>;
	if (props.partner?.id) {
		promise = resource.put(props.partner.id, postBody);
	} else {
		promise = resource.post(postBody);
	}

	try {
		const response = await promise;

		emit('saved', response);

	} catch (e) {
		return handleFormError(e as Error, errors);
	}
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(PageLayout, {
    "page-title": _ctx.pageTitle,
    "base-tag": "form",
    onSubmit: _withModifiers(save, ["prevent"])
  }, _createSlots({
    "header-actions": _withCtx(() => [
      _createVNode(AppButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [
              _createTextVNode("Avbryt")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(AppButton, { type: "submit" }, {
        default: _withCtx(() => [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [
              _createTextVNode("Spara")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 2
  }, [
    (_ctx.partner !== null)
      ? {
          name: "content",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _withDirectives((_openBlock(), _createElementBlock("h2", null, [
                _createTextVNode("Information")
              ])), [
                [_directive_translate]
              ]),
              _createVNode(AppFormGroup, {
                id: "partner_identity_number",
                errors: errors.value.identity_number,
                label: _unref($gettext)('Organisationsnummer')
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.partner.id ? AppInput : AppCompanyRecordInput), {
                    id: "partner_identity_number",
                    modelValue: data.value.identity_number,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.identity_number) = $event)),
                    required: "",
                    onCompanyRecordResult: handleCompanyRecordResult
                  }, null, 40, ["modelValue"]))
                ]),
                _: 1
              }, 8, ["errors", "label"]),
              _createVNode(AppFormGroup, {
                id: "partner_name",
                errors: errors.value.name,
                label: _unref($gettext)('Namn')
              }, {
                default: _withCtx(() => [
                  _createVNode(AppInput, {
                    id: "partner_name",
                    modelValue: data.value.name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.name) = $event)),
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["errors", "label"]),
              _createVNode(AppFormGroup, {
                id: "partner_contact_name",
                errors: errors.value.contact_name,
                label: _unref($gettext)('Kontaktperson')
              }, {
                default: _withCtx(() => [
                  _createVNode(AppInput, {
                    id: "partner_contact_name",
                    modelValue: data.value.contact_name,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.value.contact_name) = $event)),
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["errors", "label"]),
              _createVNode(AppFormGroup, {
                id: "partner_email",
                errors: errors.value.email,
                label: _unref($gettext)('E-postadress')
              }, {
                default: _withCtx(() => [
                  _createVNode(AppInput, {
                    type: "email",
                    id: "partner_email",
                    modelValue: data.value.email,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.value.email) = $event)),
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["errors", "label"]),
              _createVNode(AppFormGroup, {
                id: "partner_phone",
                errors: errors.value.phone,
                label: _unref($gettext)('Telefonnummer')
              }, {
                default: _withCtx(() => [
                  _createVNode(AppInput, {
                    type: "tel",
                    id: "partner_phone",
                    modelValue: data.value.phone,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data.value.phone) = $event)),
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["errors", "label"]),
              _createVNode(AppFormGroup, {
                id: "partner_market",
                errors: errors.value.market,
                label: _unref($gettext)('Marknad')
              }, {
                default: _withCtx(() => [
                  _createVNode(AppSelect, {
                    id: "partner_market",
                    modelValue: market.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((market).value = $event)),
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createElementBlock("option", _hoisted_2, [
                        _createTextVNode("(Välj)")
                      ])), [
                        [_directive_translate]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markets.value, (market) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: market.id,
                          value: market.id
                        }, _toDisplayString(market.name), 9, _hoisted_3))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["errors", "label"]),
              _createVNode(AppFormGroup, {
                id: "partner_signed_gdpr",
                errors: errors.value.signed_gdpr,
                label: _unref($gettext)('Har signerat GDPR-avtal')
              }, {
                before: _withCtx(() => [
                  _createVNode(AppCheck, {
                    id: "partner_signed_gdpr",
                    modelValue: data.value.signed_gdpr,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((data.value.signed_gdpr) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["errors", "label"]),
              _createVNode(AppFormGroup, {
                id: "partner_signed_privacy",
                errors: errors.value.signed_privacy,
                label: _unref($gettext)('Har signerat sekretessavtal')
              }, {
                before: _withCtx(() => [
                  _createVNode(AppCheck, {
                    id: "partner_signed_privacy",
                    modelValue: data.value.signed_privacy,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((data.value.signed_privacy) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["errors", "label"])
            ]),
            (data.value.invoice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _withDirectives((_openBlock(), _createElementBlock("h2", null, [
                    _createTextVNode("Fakturering")
                  ])), [
                    [_directive_translate]
                  ]),
                  _createVNode(AppFormGroup, {
                    id: "partner_invoice_target",
                    errors: errors.value.invoice?.target,
                    label: _unref($gettext)('Fakturera')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppSelect, {
                        id: "partner_invoice_target",
                        modelValue: data.value.invoice.target,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((data.value.invoice.target) = $event)),
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createElementBlock("option", _hoisted_5, [
                            _createTextVNode("(Välj)")
                          ])), [
                            [_directive_translate]
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(invoiceTargetNames)), ([target, targetName]) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: target,
                              value: target
                            }, _toDisplayString(targetName), 9, _hoisted_6))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["errors", "label"]),
                  _createVNode(AppFormGroup, {
                    id: "partner_invoice_address",
                    errors: errors.value.invoice?.address,
                    label: _unref($gettext)('Adress')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppInput, {
                        id: "partner_invoice_address",
                        modelValue: data.value.invoice.address,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((data.value.invoice.address) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["errors", "label"]),
                  _createVNode(AppFormGroup, {
                    id: "partner_invoice_zipcode",
                    errors: errors.value.invoice?.zipcode,
                    label: _unref($gettext)('Postnummer')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppInput, {
                        id: "partner_invoice_zipcode",
                        modelValue: data.value.invoice.zipcode,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((data.value.invoice.zipcode) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["errors", "label"]),
                  _createVNode(AppFormGroup, {
                    id: "partner_invoice_city",
                    errors: errors.value.invoice?.city,
                    label: _unref($gettext)('Postort')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppInput, {
                        id: "partner_invoice_city",
                        modelValue: data.value.invoice.city,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((data.value.invoice.city) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["errors", "label"]),
                  _createVNode(AppFormGroup, {
                    id: "partner_invoice_email",
                    errors: errors.value.invoice?.email,
                    label: _unref($gettext)('E-postadress')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppInput, {
                        type: "email",
                        id: "partner_invoice_email",
                        modelValue: data.value.invoice.email,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((data.value.invoice.email) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["errors", "label"]),
                  _createVNode(AppFormGroup, {
                    id: "partner_allowed_demo_customers",
                    errors: errors.value.allowed_demo_customers,
                    label: _unref($gettext)('Tillåtet antal demokunder')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppInput, {
                        type: "number",
                        id: "partner_allowed_demo_customers",
                        modelValue: data.value.allowed_demo_customers,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((data.value.allowed_demo_customers) = $event)),
                        min: "0",
                        step: "1"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["errors", "label"])
                ]))
              : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["page-title", "onSubmit"]))
}
}

})